import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { AudioConferenceCall } from "../../../models";
import { SendOutboundDtmfRequestModel } from "../../../models/api/Call";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  callSid?: string | null;
  selectedCall?: AudioConferenceCall | null;
  onSendOutboundDtmf: (value: SendOutboundDtmfRequestModel) => Promise<any>;
};

const keypadRows = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["*", "0", "#"],
];

export function ModalOutboundDtmfDial({
  show,
  handleShow,
  callSid,
  selectedCall,
  onSendOutboundDtmf,
}: Props) {
  const sendQueueRef = useRef(Promise.resolve());
  const [codeInput, setCodeInput] = useState("");
  const [legCallSidInput, setLegCallSidInput] = useState("");

  useEffect(() => {
    if (!show) {
      setCodeInput("");
      setLegCallSidInput("");
    }
  }, [show]);

  useEffect(() => {
    if (selectedCall?.callSid) {
      setLegCallSidInput(selectedCall.callSid);
    }
  }, [selectedCall?.callSid]);

  const appendKey = (digit: string) => {
    setCodeInput((prev) => prev + digit);

    if (!callSid || !legCallSidInput) {
      console.log("DTMF send skipped: missing identifier", {
        callSid,
        legCallSid: legCallSidInput,
      });
      return;
    }

    const currentCallSid = callSid;
    const currentLegCallSid = legCallSidInput;

    sendQueueRef.current = sendQueueRef.current.then(async () => {
      try {
        await onSendOutboundDtmf({
          callSid: currentCallSid,
          legCallSid: currentLegCallSid,
          digits: digit,
        });
      } catch (error) {
        console.error(error);
      }
    });
  };

  return (
    <Modal show={show} onHide={() => handleShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Keypad</Modal.Title>
      </Modal.Header>

      <Modal.Body className="dialer-modal-body">
        <div className="dialer-modal">
          <div className="d-flex flex-column justify-content-center align-items-center dialer-content">
            <div className="d-flex flex-row">
              <div
                className="dialer-output shadow-sm"
                style={{
                  minWidth: codeInput.length > 25 ? codeInput.length * 10 + "px" : "250px",
                }}
              >
                <input
                  className="border form-control text-center"
                  value={codeInput}
                  readOnly
                  onKeyDown={(event) => event.preventDefault()}
                  onPaste={(event) => event.preventDefault()}
                  placeholder="Enter code"
                  style={{
                    minWidth: codeInput.length > 25 ? codeInput.length * 10 + "px" : "250px",
                  }}
                />
              </div>
            </div>

            <div className="key-row-wrapper mt-3">
              {keypadRows.map((row) => (
                <div className="key-row" key={row.join("-")}>
                  {row.map((digit) => (
                    <button
                      key={digit}
                      value={digit}
                      className="btn btn-light shadow-sm ripple"
                      type="button"
                      onClick={() => appendKey(digit)}
                    >
                      {digit}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
